import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import PricingCards from '@/components/Pricing/PricingCards';
import PricingTable from '@/components/Pricing/PricingTable';
import { PlanTier } from '@/data/plans';
import { setPendingPlanTier } from '@/libs/pendingPlan';
import styles from '../../HomepageSections.module.scss';
import { SectionHeading } from '../shared/SectionHeading';

export const PricingSection = () => {
  const router = useRouter();
  const { t } = useTranslation('landing');

  const handleSelect = (tier: Exclude<PlanTier, 'Enterprise'>) => {
    setPendingPlanTier(tier);
    router.push(`/sign-up?plan=${tier}`);
  };

  const handleContact = () => {
    router.push('/?contact=sales');
  };

  return (
    <section className={styles.pricingSection} id='pricing'>
      <div className={styles.wideShell}>
        <SectionHeading
          eyebrow={t('homepage.pricing.eyebrow')}
          title={t('homepage.pricing.title')}
          description={t('homepage.pricing.description')}
        />
        <div className={styles.pricingCards}>
          <PricingCards onSelect={handleSelect} onContact={handleContact} />
        </div>
        <small className={styles.pricingNote}>{t('homepage.pricing.note')}</small>
        <div className={styles.pricingCompare}>
          <h3>{t('homepage.pricing.compareTitle')}</h3>
          <PricingTable />
        </div>
      </div>
    </section>
  );
};
